<template>
  <div class="d-flex justify-content-center align-items-center" style="min-height: 100vh;">
    <b-spinner />
  </div>
</template>

<script>
const SIGN_URL = process.env.VUE_APP_SIGN_URL || 'http://localhost:8084';

export default {
  name: 'SignContract',
  mounted() {
    // All signing happens in the dedicated Sign app
    const token = this.$route.params.token;
    window.location.href = `${SIGN_URL}/sign/${token}`;
  },
};
</script>
